import array from '@mailobj-browser/front/js/utils/array.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import remove from '@mailobj-browser/front/js/tree/remove.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import submit from '@mailobj-browser/front/js/events/types/submit.js'
import { tapUp } from '@mailobj-browser/front/js/events/listeners/builtins/tap.js'
import keyUp from '@mailobj-browser/front/js/events/types/keyUp.js'
import * as hotkey from '../../hotkey/hotkey.js'
import * as lightbox from '../lightbox.js'
import globals from '../../ea/globals.js'
import * as utilities from '../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const modals = new WeakMap()
const templates = new WeakMap()

export const onTapUp = object(tapUp, {
  hooks: array([
    preventDefault
  ]),
  task: async (anchor) => {
    if (modals.has(anchor)) {
      const modal = modals.get(anchor)
      
      remove(modal)
      modals.delete(anchor)
      
      return
    }

    const modal = await open(templates.get(anchor), anchor)

    modals.set(anchor, modal)
    lightbox.focus(modal)
    
    queueMicrotask(async () => {
      await removed(modal)
      modals.delete(anchor)
    })
  }
})

const onKeyUp = object(listener, {
  type: keyUp,
  passive,
  task: (anchor, { key }) => {
    if (key === 'Enter') {
      onTapUp.trigger(anchor)
    }
  }
})
/*
const onSubmit = object(listener, {
  type: submit,
  passive,
  task: (subForm) => {
    const modal = subForm.closest(`.${utilities.elements.modal}`)
    const { href, ownerDocument } = lightbox.opener(modal)
    const { activeElement } = ownerDocument
    const { name, value } = activeElement
    const url = new URL(href)
    const { searchParams } = url
    const entries = [...new FormData(subForm), [name, value]]
    
    for (const [name, value] of entries) {
      searchParams.set(name, `${value}`)
    }
    
    globals.ea_link(href, '', null)
  }
})
*/
export const open = async (
  template,
  anchor = null
) => {
  const { ownerDocument } = template
  const container = one(`.${utilities.elements.aside_lightboxes}`, ownerDocument)
  const modal = await lightbox.open(template, container, anchor, true)
  /*
  const modal = await lightbox.parse(template, container, anchor, true)

  const form = one('form[target="_self"]', modal)

  if (form && anchor.closest('form')) {
    onSubmit.listen(form)
  }
  */
  
  hotkey.disable(modal)

  return modal
}

export default template => {
  const { parentNode } = template

  templates.set(parentNode, template)
  onTapUp.listen(parentNode)
  onKeyUp.listen(parentNode)
}